import { useSupabaseCallback } from "../../server/supabase/hooks";
import { SupabaseBrandKitService } from "./server/brand-kit-service";
import { sortLogos } from "./utils";

import type { BrandInfoSelected } from "./types";

export const useGetBrandingBarDefaults = (): (() => Promise<
  Pick<BrandInfoSelected, "color" | "logo"> | undefined
>) =>
  useSupabaseCallback(async ({ supabase }) => {
    const { data } = await new SupabaseBrandKitService(supabase).maybeGet();

    if (!data) return undefined;

    const logos = sortLogos(data.logos ?? []);
    const colors = data.colors ?? [];

    return {
      logo: logos.find((logo) => logo.is_default_logo),
      color: colors.find((color) => color.is_default_primary_color),
    };
  }, []);
